import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideConfiguratorAddPopUp } from '../../Actions/Cart.action';
import Popup from 'reactjs-popup';
import { translate } from '../../Services/translation';

const ConfiguratorAddToCartPopUp = () => {
    const dispatch = useDispatch();
    const { showConfiguratorAddPopUp, checkoutUrl } = useSelector((state) => state.cart);  

    const hide = () => {
        dispatch(hideConfiguratorAddPopUp());
    }

    return <Fragment>
        {showConfiguratorAddPopUp && <Popup
                open={true}
                closeOnDocumentClick={false}
            >
                <div className="add-to-cart">
                    <div className="modal">                       
                        <div className="content">

                            <h3 className="add-to-cart__heading"><i className="add-to-cart__icon"></i>
                                {translate("configuratorAddedToCartHeaderPrefix")} - {translate('addtocart.addedtocart')}
                            </h3>
                            <div className="add-to-cart__product-row">                               
                            </div>
                            <div className="add-to-cart__button-container">
                                <button className="button button--ghost" onClick={() => hide()}>{translate('addtocart.keepshopping')}</button>
                                <a href={checkoutUrl} className="button button--buy-button cart-pop-up">
                                    {translate('addtocart.tocheckout')}
                                    <span className="button__buy-icon"></span>
                                </a>
                            </div>                            
                        </div>
                    </div>
                </div>
            </Popup>}
    </Fragment>
    
}

export default ConfiguratorAddToCartPopUp;